function isArray(obj: any) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(obj) === "[object Array]";
  }
  return Array.isArray(obj);
}

export default isArray;
